import { ThemeName } from 'modules/TradingChart/components/TradingView/sources/charting_library.min';

export function isSystemDefaultThemeDark() {
  if (
    typeof window !== 'undefined' &&
    window.matchMedia &&
    window.matchMedia('(prefers-color-scheme: dark)').matches
  ) {
    return true; // Dark mode is enabled
  }

  return false; // Light mode is enabled
}

export function getSystemDefaultTheme() : ThemeName {
    return isSystemDefaultThemeDark() ? 'dark' : 'light';
}
